// @ts-nocheck
import { Disclaimer } from '../pages/Disclaimer';
import { Splash } from '../pages/Splash';
import { CharacterSelection } from '../pages/CharacterSelection';
import { GameInstructions } from '../pages/GameInstructions';
import { GamePlay } from '../pages/GamePlay';
import { GameResults } from '../pages/GameResults';
import { CameraAccess } from '../pages/CameraAccess';
import { ToyScan } from '../pages/ToyScan';
import { ScanConfirmation } from '../pages/ScanConfirmation';

let idx = 0;
export const pagesMap = {
  DISCLAIMER: idx,
  SPLASH: ++idx,
  CAMERA_ACCESS: ++idx,
  CARD_SCAN: ++idx,
  SCAN_CONFIRMATION: ++idx,
  CHARACTER_SELECTION: ++idx,
  GAME_INSTRUCTIONS: ++idx,
  GAME_PLAY: ++idx,
  END_GAME: ++idx,
};

export default pagesMap;

export const pageComponents = {
  DISCLAIMER: Disclaimer,
  SPLASH: Splash,
  CAMERA_ACCESS: CameraAccess,
  CARD_SCAN: ToyScan,
  SCAN_CONFIRMATION: ScanConfirmation,
  CHARACTER_SELECTION: CharacterSelection,
  GAME_INSTRUCTIONS: GameInstructions,
  GAME_PLAY: GamePlay,
  END_GAME: GameResults,
};
